<script>
  import { onMount } from "svelte";
  import { useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  import { useUrlParams } from "@stores/urlStore.js";
  import { Grid, Row, Column, Button } from "carbon-components-svelte";

  import Events32 from "carbon-icons-svelte/lib/Events32";
  import TimePlot32 from "carbon-icons-svelte/lib/TimePlot32";
  import Timer32 from "carbon-icons-svelte/lib/Timer32";
  import ChartTSne32 from "carbon-icons-svelte/lib/ChartTSne32";
  import DataReference32 from "carbon-icons-svelte/lib/DataReference32";
  import KpiCard from "lib/components/KPICard.svelte";
  import LimitationList from "../components/LimitationList.svelte";
  import AnonymizationList from "../components/AnonymizationList.svelte";
  import { formatTimeDelta } from "lib/util/formatfunctions.js";

  import { SectionWrapper, Accordion } from "paxray-components-svelte";
  import SideKpi from "../../../../lib/components/sideKPI.svelte";
  import ButtonNew from "../../../../lib/components/ButtonNew.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  const urlParams = useUrlParams();

  const navigate = useNavigate();

  let idLimitation;
  let idAnonymization;

  let kpis = {
    nusers: 0,
    nclicks: 0,
    nkeystrokes: 0,
    timesincestart: 0,
    totaltime: 0,
  };

  $: ({ idproject } = $urlParams);

  $: if (idproject) {
    loadProjectData();
  }

  function startAnalysis() {
    fetchWithSession(`/api/damprojects/completeDAMProjectStep/${idproject}/3`, {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => {
        navigate(`${ROUTES.analysis.treemap}?analysisid=${data.analysisid}`);
      });
  }

  function loadProjectData() {
    fetchWithSession(`/api/damprojects/getProjectLimitations/${idproject}/1`)
      .then((res) => res.json())
      .then((data) => {
        idLimitation = data;
      });

    fetchWithSession(`/api/damprojects/getProjectAnonymizations/${idproject}/2`)
      .then((res) => res.json())
      .then((data) => {
        idAnonymization = data;
      });
  }
</script>

<SectionWrapper>
  <div class="main" slot="main">
    <div class="table_heading info_wrapper">
      <!-- @Adrian hier bitte noch einen kurzen text, was wirklich hier passiert -->
      <h5>Main Recording</h5>
      <div class="info">
        You are currently runnning the main recording. Soon you will have the
        first results ready for analysis.
      </div>
    </div>

    <div class="tables_wrapper">
      <div class="table_heading">
        <h5>Limitations</h5>
        <div class="info">
          The following limitations are applied in the main recording:
        </div>
      </div>

      <LimitationList  editable={false} />

      <div class="table_heading">
        <h5>Anonymization Rules</h5>
        <div class="info">
          The following anonymization rules are applied in the main recording:
        </div>
      </div>

      <AnonymizationList {idAnonymization} editable={false} />
    </div>

    <ButtonNew
      secondary={true}
      setting={true}
      text="Start Analysis"
      on:click={startAnalysis}
    />

    <!-- @Adrian alter Button auskommentiert, falls neuer Fehler wirft -->
    <!-- <Button on:click={startAnalysis}>Start Analysis</Button> -->
  </div>
  <div class="menu" slot="menu">
    <Accordion open={true} heading="KPIs">
      <div class="kpi_wrapper">
        <SideKpi name="Users" value={kpis["nusers"]} />
        <SideKpi name="Clicks" value={kpis["nclicks"]} />
        <SideKpi name="Keystrokes" value={kpis["nkeystrokes"]} />
        <SideKpi
          name="Days recorded"
          value={formatTimeDelta(kpis["timesincestart"])}
        />
        <SideKpi
          name="Time recorded"
          value={formatTimeDelta(kpis["totaltime"])}
        />
      </div>
    </Accordion>
  </div>
</SectionWrapper>

<style>
  .main {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    gap: 1rem;
  }

  .kpi_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .tables_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .table_heading {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #fc8b5d;
    color: var(--pax-white);
    border-left: 0.6rem solid var(--pax-orange);
    padding: 0.6rem 1rem;
    border-radius: 0.5rem;
  }

  .info_wrapper {
    background: var(--pax-black);
    color: white;
    border-left: 0;
  }
</style>
